export const CLEAR_ARTICLES = 'articles/clear'

export const INCLUDE_ARTICLES = 'articles/include'

export const SET_ARTICLES_SCROLL = 'articles/scroll/set'

export const SET_ARTICLES_TOTAL = 'articles/total/set'

export const SET_ARTICLES_HASMORE = 'articles/hasMore/set'

export const SET_KB_TYPING = 'kb/typing'

export const SET_KB_LOADER = 'kb/loader'

export const SET_KB_SEARCH_RESULT = 'kb/searchResult'

export const SET_CURRENT_ARTICLE = 'kb/setCurrentArticle'

export const SET_IS_CURRENT_ARTICLE_LOADING = 'kb/setIsCurrentArticleLoading'
